///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BomDTO, GtthLayeredBomSummaryDTO } from '../../../generated/shared-types.model';
import { map, Observable } from 'rxjs';
import { BomSummaryDTO, LayeredBomSummaryDTO } from './bom-summary.models';

@Injectable({ providedIn: 'root' })
export class BomSummaryService {
    constructor(private readonly http: HttpClient) {}

    getBomSummary(projectId: number, bom: BomDTO): Observable<LayeredBomSummaryDTO> {
        return this.http.put<GtthLayeredBomSummaryDTO>(`/api/reports/${projectId}/bom-summary`, bom).pipe(
            map((layeredBomSummaryReport) => {
                const extendedReport = layeredBomSummaryReport as LayeredBomSummaryDTO;

                extendedReport.summaryPerLayer.forEach((summaryPerLayer: BomSummaryDTO) => {
                    summaryPerLayer.typesCount = 0;
                    summaryPerLayer.installedTypesCount = 0;
                    summaryPerLayer.servicesCount = 0;
                    summaryPerLayer.installedServicesCount = 0;

                    for (const productName in summaryPerLayer.typeName) {
                        summaryPerLayer.typesCount += summaryPerLayer.typeName[productName].count;
                        summaryPerLayer.installedTypesCount += summaryPerLayer.typeName[productName].installedCount;
                    }

                    summaryPerLayer.accessoriesCount = {};
                    summaryPerLayer.installedAccessoriesCount = {};

                    for (const accessoriesMapKey in summaryPerLayer.accessoriesMap) {
                        summaryPerLayer.accessoriesCount[accessoriesMapKey] = 0;
                        summaryPerLayer.installedAccessoriesCount[accessoriesMapKey] = 0;
                        for (const accessoryName in summaryPerLayer.accessoriesMap[accessoriesMapKey]) {
                            const summaryRecord = summaryPerLayer.accessoriesMap[accessoriesMapKey][accessoryName];
                            summaryPerLayer.accessoriesCount[accessoriesMapKey] += summaryRecord.count;
                            summaryPerLayer.installedAccessoriesCount[accessoriesMapKey] += summaryRecord.installedCount;
                        }
                    }
                });
                return extendedReport;
            })
        );
    }
}
